import { Box, Chip, Typography } from "@mui/material"
import { CloseFilledOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"

interface WarehouseLocationCardProps {
  warehouseId: string
  label: string
  onRemove: (warehouseId: string) => void
}

export const WarehouseLocationCard: FC<WarehouseLocationCardProps> = ({ warehouseId, label, onRemove }) => (
  <Chip
    label={
      <Box className='flex min-h-9 flex-col justify-center'>
        <Typography className='text-sm font-normal text-gray-800'>{label}</Typography>
      </Box>
    }
    onDelete={() => onRemove(warehouseId)}
    deleteIcon={<CloseFilledOutlined className='!h-4 !w-4' />}
    className='h-auto w-full justify-between rounded-lg bg-gray-200'
    sx={{
      "& .MuiChip-label": { display: "block", padding: "8px 12px", whiteSpace: "normal" },
      "& .MuiChip-deleteIcon": { marginRight: "8px", flexShrink: 0 },
    }}
    data-testid={`sales.warehouse-location-card.${warehouseId}`}
  />
)
